import React from 'react';
import { Direction, getTrackBackground, Range } from 'react-range';
import { useStyletron } from 'baseui';
type VerticalSliderProps = {
  min: number;
  max: number;
  value: number;
  onChange: (newValue: number) => void;
  onFinalChange?: (value: number) => void;
};
export const VerticalSlider = ({
  min,
  max,
  value,
  onChange,
  onFinalChange
}: VerticalSliderProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  })}>
      <Range direction={Direction.Up} values={[value]} min={min} max={max} onChange={newValues => onChange(newValues[0]!)} onFinalChange={values => onFinalChange?.(values[0]!)} renderTrack={({
      props,
      children
    }) =>
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} style={{
      ...props.style,
      display: 'flex',
      justifyContent: 'center',
      height: theme.sizing.scale2400
    }} data-testid="volume-track-container">
            <div ref={props.ref} className={css({
        width: theme.sizing.scale0,
        height: theme.sizing.scale2400,
        alignSelf: 'center',
        position: 'relative'
      })} style={{
        background: getTrackBackground({
          values: [value],
          colors: [theme.colors.contentPrimary, theme.colors.contentInverseSecondary],
          min,
          max,
          direction: Direction.Up
        })
      }} data-testid="vertical-slider-track">
              {children}
            </div>
          </div>} renderThumb={({
      props
    }) => <div {...props} className={css({
      height: theme.sizing.scale500,
      width: theme.sizing.scale500,
      backgroundColor: theme.colors.contentPrimary,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      outline: 'none',
      border: 'none',
      padding: '0'
    })} style={{
      ...props.style
    }} data-testid="vertical-slider-thumb" />} />
    </div>;
};